export default __webpack_public_path__ + "74fa0ea8ccb73f0d9c7763431f82d676.png";